import { createApp } from "vue";
import html from "./orderManagerCreate.html";

import flatpickrVue from 'vue-flatpickr-component';
import { dropdownFilter } from './composant/dropdownFilter';

import b2bTypeahead from "./composant/b2bTypeahead";
import { toDate, may, flatPickrConfig } from "./composant/b2bLangue";
import { DateHelper } from "../B2bTools";
import Store from "../Store";

function nbe(object) {
	let nb = 0;
	for (let key in object) if (object[key]) nb++;
	return nb;
}

const js = ({

	url: function (echangeur) { 


      
        let u = Store.get('getURUL')();
		if(!echangeur.hash) echangeur.hash ={};
        if(!echangeur.hash.u) echangeur.hash.u= u;
		// echangeur.hash.env

		echangeur.addAction('b2b.codification.select', { classe: "ordertype" }, '', 'ordertype');
		echangeur.addAction('b2b.codification.select', { classe: "orderdepartment" }, '', 'orderdepartment');
		echangeur.addAction('b2b.codification.select', { classe: "incoterm" }, '', 'incoterm');
		echangeur.addAction('b2b.order.new', echangeur.hash, '', 'data');
	},
	onLoad: function (echangeur) {
		let env = Store.get('getURUL')();
		console.log(`📝 ${env} isEdi ${this.isEdi}`)
		let isEdi = this.isEdi;
		let THIS = this;
		this.echangeur	= echangeur;
		//
		//
		const echangeurCodification = echangeur.data.codification;
		if (echangeurCodification.customer.rows.length > 1) {
			echangeurCodification.customer.rows.unshift({ k: null, v: "..." })
		}

		let libIncoterm = echangeur.incoterm.rows;
		let libOrdertype = echangeur.ordertype.rows;
		let libOrderdepartment = echangeur.orderdepartment.rows;
		let libSeason = [];

		let arrayTokv = function (arr, arrLib) {
			let adef = {};
			arrLib.forEach(element => { adef[element.k] = element; });

			let rows = arr.map(element => {
				if (adef[element]) return adef[element];
				return { k: element, v: element };
			});
			if (arr.length > 1) rows.unshift({ k: null, v: "..." })
			return rows;
		}
		let getKv = function (item, adic) {
			let kv = adic.find(el => {
				return (el.k == item)
			})
			if (!kv) kv = { k: item, v: item }
			return kv
		}




		// echangeurSaisie
		const app = createApp({

			data: function () {
				const d = {
					isEdi: isEdi,
					saisie: {
						env:env,
						brandname: null,
						pseudobrandname: null, //  clientK~brandnameId
						customer: null,
						customerV: null, // 
						user: null,
						door: null,
						orderdepartment: null,
						ordertype: null,
						season: null,
						withdates:true,
						onstock:false,
						dateEnd: null,
						dateStart: null,
						stock: null,
						withedi:false,
						edi:"",
						sdept:null,
						idSender : null
					},

					errors: {},
					codification: echangeurCodification,
					select: {
						orderdepartment: [],
						ordertype: [],
						season: [],
						stock: [],

						dateEnd: null,
						dateStart: null,
						sdept : [],
						
						doors: [],
					},
					log: {
						incoterm: null,
						tarif: null,
					},
					tocs: [],
					saisiepo: false,
					version: 0,
					//
					wwwflatPickrConfig: Object.assign({}, flatPickrConfig)
				}
				/*if (this.action.p.duplicatefrom) {
					const originalOrder = await wshOrder.chargeDocById(this.action.p.duplicatefrom);
					d.saisie.customer = originalOrder.customer;
					d.saisie.customerV = originalOrder.customer.v;
					d.saisie.door = originalOrder.door;
					d.saisie.brandname = originalOrder.brandname;
					d.saisie.season = originalOrder.season;
					d.saisie.ordertype = originalOrder.ordertype;
					d.saisie.orderdepartment = originalOrder.orderdepartment; 
				}*/
				return d;
			},
			components: {
				"type-ahead": b2bTypeahead,
				'flatpickr-vue': flatpickrVue,
				'dropdown-filter': dropdownFilter
			},
			methods: {
				create() {
					let saisie = this.saisie;
					let select = this.select;

					const errors = {}

					if (!saisie.customer) 		 errors.customer 	= { k: "required" };
					if (!saisie.orderdepartment) errors.orderdepartment = { k: "required" };
					if (!saisie.ordertype) 		 errors.ordertype 	= { k: "required" };
					if (!saisie.season) 		 errors.season 		= { k: "required" };
					if (saisie.onstock && !saisie.stock) errors.stock = { k: "required" };

					if (saisie.withdates)  {
						if (!saisie.dateEnd) errors.dateEnd = { k: "required" };
						if (saisie.dateEnd && saisie.dateEnd > select.dateEnd) errors.dateEnd = { k: "msg", v: "Date end > date end max" }

						if (!saisie.dateStart) errors.dateStart = { k: "required" };
						if (saisie.dateStart && saisie.dateStart < select.dateStart) errors.dateStart = { k: "msg", v: "Date start < date start min" }
						if (saisie.dateStart && DateHelper.now() > saisie.dateStart) errors.dateStart = { k: "msg", v: "Date start > now" }

						if (!errors.dateStart && !errors.dateEnd) {
							let dateNow = DateHelper.now();
							if (saisie.dateStart > saisie.dateEnd) errors.dateStart = { k: "msg", v: "Date start > date end" }
							if (dateNow > saisie.dateStart) errors.dateStart = { k: "msg", v: "Date start < now" }
						}
					}
					let nbError = nbe(errors);
					this.errors = errors;
					this.errors.nb = nbError;
					if (nbError == 0) THIS.submit();
				},

				selectpseudobrandname() {		// saisie.brandname est modifié.
					const item = this.codification.customer.rows.find(u => u.k == this.saisie.pseudobrandname);
					this.saisie.customer = item.clientK;
					this.saisie.customerV = "";
					this.saisie.brandname = item.brandname;
					this.saisie.filterOrderdepartments = item.orderdepartments;
				},
				selectcustomer(item) {
					console.log(item)
					this.saisie.customer = item.k;
					this.saisie.customerV = item.v;
					this.saisie.brandname = "";
					this.saisie.filterOrderdepartments = "";
				},
				erasecustomer() {
					this.saisie.customer = null; 
				},
				typeaheadcustomer() {
					return async function (key) {
						let rows = await THIS.rest("b2b.customer.typeahead", { k: key, limit: 10 ,env:env, isEdi})
						return rows.map(u => ({ k: u.k, v: u.v + " (" + u.k + ")" }));
					}
				},
				toDate(value) {
					return toDate(value)
				},
				close: function () {
					// @ts-ignore
					THIS.fin();
				},
				async construitChoix() {

					let saisie = this.saisie;
					let select = this.select;
					let tocs = this.tocs;
					//
					// Dans le cas d'un brandname, le buyer apparait dans certains orderdepartments
					// on filtre les tocs
					console.log('tocs',tocs )					
					if (saisie.filterOrderdepartments) {
						tocs = tocs.filter(u => saisie.filterOrderdepartments.includes(u.orderdepartment))
					}
					console.log('saisie.filterOrderdepartments',saisie.filterOrderdepartments )					

					if (saisie.customer) {
						if (select.doors.length == 1) saisie.door = select.doors[0].k;
					}
					if (tocs.length) {
						let incoterm = getKv(tocs[0].incoterm, libIncoterm);
						this.log.incoterm = (incoterm.v) ? incoterm.v : incoterm;
					}
					let lChoix = tocs;
					let orderdepartment = [];
					if (true) {
						// lChoix = lChoix.filter(el => (el.ordertype == saisie.ordertype));
						let set = new Set(lChoix.map(u => u.orderdepartment));
						orderdepartment = [...set];
						if (orderdepartment.length == 1) saisie.orderdepartment = orderdepartment[0];
					}
					console.log('lChoix',lChoix )


					let ordertype = [];
					if (saisie.orderdepartment) {
						lChoix = lChoix.filter(el => (el.orderdepartment == saisie.orderdepartment));
						//
						let set = new Set(lChoix.map(el => el.ordertype));
						ordertype = [...set];
						if (ordertype.length == 1) saisie.ordertype = ordertype[0];
					}

					let season = [];
					if (saisie.ordertype) {
						lChoix = lChoix.filter(el => (el.ordertype == saisie.ordertype));
						//
						let set = new Set(lChoix.map(u => u.season));
						season = [...set];
						if (season.length == 1) saisie.season = season[0];
					}

					this.saisie.stock = null
					this.select.stock = [];
					if (saisie.season) {
						lChoix = lChoix.filter(el => (el.season == saisie.season));
						/* if (lChoix.length > 1) console.log("Erreurs lChoix > 1", lChoix) */
						if(!lChoix[0].withdelivdates) {
							saisie.withdates	= false;
							const dateActuelle = new Date();
							var dtstart = new Date(dateActuelle);
							dtstart.setDate(dtstart.getDate() + parseFloat(lChoix[0].tbcstart));
							const start	= dtstart.getFullYear()+''+(dtstart.getMonth() + 1).toString().padStart(2, '0')+''+dtstart.getDate().toString().padStart(2, '0');
							var dtend = new Date(dateActuelle);
							dtend.setDate(dtend.getDate() + parseFloat(lChoix[0].tbcend));
							const end	= dtend.getFullYear()+''+(dtend.getMonth() + 1).toString().padStart(2, '0')+''+dtend.getDate().toString().padStart(2, '0');
							saisie.dateStart 	= start;
							select.dateStart 	= start;
							saisie.dateEnd		= end;
							select.dateEnd		= end;
						} else {
							//normalement unique 
							saisie.withdates = true;
							saisie.dateStart = lChoix[0].dateStart;
							saisie.dateEnd 	 = lChoix[0].dateEnd;
							select.dateStart = lChoix[0].dateStart;
							select.dateEnd 	 = lChoix[0].dateEnd;
						}
						select.updatable = lChoix[0].updatable;
						this.log.tarif = lChoix[0].tarif;
						this.saisie.onstock   = Boolean(lChoix[0].onstock);
						this.saisie.withdates = Boolean(lChoix[0].withdelivdates);
						this.saisie.withedi   = Boolean(lChoix[0].withedi);
						

						this.wwwflatPickrConfig.minDate = select.dateStart;
						this.wwwflatPickrConfig.maxDate = select.dateEnd;


						this.select.stock = this.codeStock.map(element => ({ k: element, v: element }) );
						this.saisie.stock = this.codeStock[0];
					}


					console.log('tborderdepartment',orderdepartment,libOrderdepartment )

					select.ordertype = arrayTokv(ordertype, libOrdertype);
					select.orderdepartment = arrayTokv(orderdepartment, libOrderdepartment);
					console.log('select.orderdepartment',select.orderdepartment )					
					select.season = arrayTokv(season, libSeason);
				},


				may: function (key) {
					return may(key);
				},

			},
			watch: {
				async "saisie.customer"(value) {
					if (value) {
						const k = value;	//!!!!
						const retour = await THIS.rest("b2b.toc.customer", { k, env,fromEdiSearch :isEdi});
						this.tocs = retour.rows;
						this.select.sdept = (retour.sdept)? retour.sdept : [];
						
						console.log(retour.sdept)
						
						this.select.doors = retour.doors;
						if (this.select.doors.length > 1) this.select.doors.unshift({ k: null, v: "..." });
						this.saisiepo = (retour.saisiepo);
						this.codeStock = retour.codestock;

						this.select

						console.log('codeStock',retour.codestock);
					} else {
						this.tocs = [];
						this.select.doors = [];
						this.select.dateEnd = null;
						this.select.dateStart = null;
						this.codeStock = [];
					}
					//
					(["ordertype", "orderdepartment", "season", "dateEnd", "dateStart", "dateEnd"]).forEach(el => { this.saisie[el] = null });
					this.construitChoix();
				},
				"saisie.orderdepartment"() {
					(["ordertype", "season", "dateEnd", "dateStart", "dateEnd"]).forEach(el => { this.saisie[el] = null });
					this.select.dateEnd = null;
					this.select.dateStart = null;
					this.construitChoix();
				},
				"saisie.ordertype"() {
					(["season", "dateEnd", "dateStart", "dateEnd"]).forEach(el => { this.saisie[el] = null });

					this.select.dateEnd = null;
					this.select.dateStart = null;
					this.construitChoix();
				},
				"saisie.season": function () {
					(["dateEnd", "dateStart"]).forEach(el => { this.saisie[el] = null });

					this.select.dateEnd = null;
					this.select.dateStart = null;
					this.construitChoix();
				}
			}

		});
		// @ts-ignore
		this.vm = app.mount(THIS.c$('._vueChargement')[0]);
		document.querySelector('._orderManagerCreateModal').style.display = "flex"

	},
	serialize: function () {
		return this.vm.$data.saisie;
	},
	action: function (echangeur, parametre) {
		echangeur.addAction('b2b.order.create', { idContexte: this.idContexte }, 'form', 'result');
	},
});

export default { js: js, html: html };

